export const ACTIONS = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_DISTRICTS: 'SET_DISTRICTS',
    SET_SELECTED_DISTRICT: 'SET_SELECTED_DISTRICT',
    ADD_DISTRICT: 'ADD_DISTRICT',
    UPDATE_DISTRICT: 'UPDATE_DISTRICT',
    DELETE_DISTRICT: 'DELETE_DISTRICT',
    SET_FILTER: 'SET_FILTER',
    SET_SORT: 'SET_SORT',
    SET_PAGE: 'SET_PAGE',
    SET_ALL_DISTRICTS: 'SET_ALL_DISTRICTS'
};

export const initialState = {
    districts: [],
    selectedDistrict: null,
    loading: false,
    error: null,
    filter: {
        name: null,
        code: null,
        status: null,
        type: null
    },
    pagination: {
        page: 0,
        size: 10,
        total: 0
    },
    sort: {
        field: 'name',
        direction: 'asc'
    },
    lastUpdated: null,
    provinceId: null
};

export const districtReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case ACTIONS.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        case ACTIONS.CLEAR_ERROR:
            return {
                ...state,
                error: null
            };

        case ACTIONS.SET_DISTRICTS:
            return {
                ...state,
                districts: action.payload.content,
                pagination: {
                    ...state.pagination,
                    total: action.payload.totalElements || action.payload.length,
                    page: action.payload.number || 0
                },
                lastUpdated: new Date().toISOString(),
                loading: false
            };
        case ACTIONS.SET_ALL_DISTRICTS:
            return {
                ...state,
                districts: action.payload,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_SELECTED_DISTRICT:
            return {
                ...state,
                selectedDistrict: action.payload,
                loading: false
            };

        case ACTIONS.ADD_DISTRICT:
            return {
                ...state,
                districts: [action.payload, ...state.districts],
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.UPDATE_DISTRICT:
            return {
                ...state,
                districts: state.districts.map((district) => (district.id === action.payload.id ? action.payload.data : district)),
                selectedDistrict: state.selectedDistrict?.id === action.payload.id ? action.payload.data : state.selectedDistrict,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.DELETE_DISTRICT:
            return {
                ...state,
                districts: state.districts.filter((district) => district.id !== action.payload),
                selectedDistrict: state.selectedDistrict?.id === action.payload ? null : state.selectedDistrict,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_FILTER:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...action.payload
                },
                pagination: {
                    ...state.pagination,
                    page: 0
                }
            };

        case ACTIONS.SET_SORT:
            return {
                ...state,
                sort: action.payload
            };

        case ACTIONS.SET_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload
                }
            };

        default:
            return state;
    }
};
